import CandidateNotesSidebar, {
  CandidateNotesSidebarComponentProps,
} from './CandidateNotesSidebar.component';

export type CandidateNotesSidebarComponentType = CandidateNotesSidebarComponentProps;

export default CandidateNotesSidebar;
